import NutritionTableStandard from './NutritionTableStandard';

export default NutritionTableStandard;
